// Запуск: ABsmartly-аудитория country = US (копия пяти новых экранов только на EN).
import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-tai-chi': {
			// /chair-tai-chi-m?safe&exp=web_male_chair_tai_chi_academy~1
			funnel: {
				id: 'ob-male-tai-chi-chair-workouts-academy',
				locale: ['en'],
			},
		},
	},
]

export default config
